export default "__VITE_ASSET__oKogImeA__"